import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import AbstractRouterLink from './internal/AbstractRouterLink';
import { Button } from 'foundations-components/transitional/components/Button';
import { clonePropTypes, cloneDefaultProps, isLegacyComponent } from './internal/utils';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`Button`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-button--page)
 * type component with router support.
 */
export default function UIRouterButton(props) {
  const {
      use = 'tertiary-light'
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  // TODO remove this logic after deprecating style & className props
  const ButtonComponent = isLegacyComponent(props, ['style', 'className']) ? UIButton : Button;
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    component: ButtonComponent,
    use: use
  }));
}
const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
  sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);

// TODO remove after deprecating UIComponents part
UIRouterButton.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, clonePropTypes(UIButton));

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterButton.defaultProps = Object.assign({}, cloneDefaultProps(UIButton), {
  use: 'tertiary-light'
});